export default __webpack_public_path__ + "static/media/login.dc289665.jpg";